var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.uid)?[_c('navigation'),_c('v-content',[_c('router-view')],1),_c('v-footer',{attrs:{"color":"blue lighten-1","app":""}},[_c('span',{staticClass:"white--text"},[_vm._v("© "+_vm._s(new Date().getFullYear()))])])]:[_c('Login')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }